// src/components/Header.jsx
import React, { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import axios from "../api/axios";
import "./Header.css";

export default function Header({ locale = "kz", setLocale = () => {} }) {
  const t = {
    kz: { home: "Басты бет", about: "Платформа туралы", contact: "Байланыс" },
    ru: { home: "Главная", about: "О проекте", contact: "Контакты" },
  }[locale];

  useEffect(() => {
    axios.defaults.headers.common["Accept-Language"] = locale;
    document.documentElement.lang = locale;
  }, [locale]);

  const changeLang = (lng) => {
    if (lng === locale) return;
    localStorage.setItem("locale", lng);
    setLocale(lng);
  };

  return (
    <header className="site-header">
      <div className="container header-inner">
        {/* Бренд-слот фиксированной ширины.
            Внутри картинка масштабируется transform'ом и НЕ сдвигает остальной layout */}
        <Link to="/" className="brand" aria-label="Home">
          <span className="brand-box">
            <img
              className="brand-mark"
              src="/img/bmsoLogoLight.svg"   /* PNG тоже ок */
              alt="Expertise"
            />
          </span>
        </Link>

        <nav className="main-nav" aria-label="Primary">
          <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : "")}>
            {t.home}
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")}>
            {t.about}
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")}>
            {t.contact}
          </NavLink>
        </nav>

        {/* язык */}
{/* язык как обычные кнопки-«пилюли» */}
<div className="lang-switch" role="group" aria-label="Тіл / Язык">
  <button
    type="button"
    className={`lang-btn ${locale === "kz" ? "active" : ""}`}
    aria-pressed={locale === "kz"}
    onClick={() => changeLang("kz")}
  >
    KZ
  </button>
  <button
    type="button"
    className={`lang-btn ${locale === "ru" ? "active" : ""}`}
    aria-pressed={locale === "ru"}
    onClick={() => changeLang("ru")}
  >
    RU
  </button>
</div>


      </div>
    </header>
  );
}
